// to transformer product according to product thumbnail interface
const setFormattedPercentOff = (price) => {
  const minPercentOff = price?.values?.[0]?.percentOff?.[0];
  const maxPercentOff = price?.values?.length > 1 ? price?.values?.[price.values.length - 1]?.percentOff?.[0] : 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const priceObj of price.values) {
    if (!priceObj.formattedPercentOff && priceObj.percentOff && priceObj.percentOff[0]) {
      priceObj.formattedPercentOff = maxPercentOff > 0 ? `(${minPercentOff}-${maxPercentOff}% off)` : `(${minPercentOff}% off)`;
    }
  }
};

const transformer = (product, includeMetaData, _, colorSwatchEnhancement) => {
  const isFromMonetization = !!product.product;
  const prod = isFromMonetization ? product.product : product;
  const id = prod?.id;
  const pricing = prod?.pricing;
  const detail = prod?.detail;
  const brandName = prod?.detail?.brand?.name ? prod?.detail?.brand?.name : prod?.detail?.brand;
  if (detail?.reviewStatistics?.aggregate?.rating) {
    detail.reviewStatistics.aggregate.rating = Number(detail?.reviewStatistics?.aggregate?.rating);
  }
  let primaryImage;
  if (prod?.imagery?.primaryImage) {
    primaryImage = prod?.imagery?.primaryImage;
  } else if (prod?.imagery?.additionalImageSource) {
    primaryImage = prod?.imagery?.additionalImageSource?.[0];
  } else {
    primaryImage = prod?.imagery?.images?.[0];
  }
  if (isFromMonetization) {
    primaryImage.filePath = `${primaryImage?.filePath }.tif?bgc=255,255,255&wid=224&qlt=90,0&layer=comp&op_sharpen=0&resMode=bicub&op_usm=0.7,1.0,0.5,0`;
  }
  // update formattedPercentOff
  if (pricing?.price?.tieredPrice?.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const price of pricing.price.tieredPrice) {
      const isDiscount = price?.values?.[0]?.type === 'discount' || false;
      if (isDiscount) {
        setFormattedPercentOff(price);
      }
    }
  }
  if (pricing?.price?.finalPrice?.values?.length) {
    setFormattedPercentOff(pricing?.price?.finalPrice);
  }
  if (!pricing?.badges) {
    const finalPrice = pricing?.price?.finalPrice;
    const { badgeIds = [], badgesMap = {} } = pricing || {};
    const topBadges = (Array.isArray(badgeIds) && badgeIds.length > 0 && badgesMap && Object.keys(badgesMap).length > 0)
      ? badgeIds.map((badgeId) => badgesMap[badgeId] || {}).slice(0, 2)
      : [];
    if (finalPrice) {
      const { applicablePromotions = [] } = finalPrice;
      const topBadgesPromoIds = topBadges.map((badge) => badge?.promoId);
      let finalPricePosition = 0;
      if (topBadgesPromoIds?.length >= applicablePromotions?.length) {
        finalPricePosition = topBadgesPromoIds.filter((promoId) => applicablePromotions?.includes(promoId))?.length;
      }
      const position = (finalPricePosition === applicablePromotions?.length) ? finalPricePosition : 0;
      const secondBadge = (topBadges?.length > 1) ? topBadges[1]?.header : '';
      if (position) {
        if (position === 2 && secondBadge && secondBadge[0] === secondBadge[0].toUpperCase()) {
          topBadges[1].header = `Plus ${secondBadge.charAt(0).toLowerCase()}${secondBadge.slice(1)}`; // eslint-disable-line no-param-reassign
        }
        topBadges?.forEach((badge, index) => {
          badge.type = (index < position) ? 'discount' : 'regular'; // eslint-disable-line no-param-reassign
        });
        topBadges.splice(position, 0, { finalPrice, secondBadgeWithFinalPrice: true }); // eslint-disable-line no-param-reassign
        delete pricing.price.finalPrice;
      }
    }
    if (pricing) {
      pricing.badges = topBadges;
    }
  }
  const identifier = prod?.identifier;

  let colorArray = [];
  let selectedColorObj = null;
  let traits;

  if (colorSwatchEnhancement) {
    traits = prod?.traits;
    const colors = traits?.colors || {};
    colorArray = colors.colorMap ? Object.values(colors.colorMap) : [];
    selectedColorObj = colorArray.find((color) => color.id === colors.selectedColor) || null;
  }

  const updatedProduct = {
    id,
    identifier,
    detail: { ...detail, brand: { name: brandName } },
    pricing,
    imagery: { primaryImage },
    ...(colorSwatchEnhancement && {
      traits: {
        ...traits,
        colors: {
          ...traits?.colors,
          colorMap: colorArray,
          selectedColor: selectedColorObj,
        },
      },
    }),
  };
  if (includeMetaData) {
    updatedProduct.meta = prod?.meta;
  }
  return updatedProduct;
};

export default transformer;
